module.exports = __webpack_public_path__ + "img/leo_micas.5b74411e.jpg";